















import { Component, Vue, Watch } from "vue-property-decorator";
import { startOfMonth, endOfMonth } from "date-fns";
import { Circle2 } from "vue-loading-spinner";
import { fileOpen, fileDownload } from "@/file-utils";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import ShiftFilter from "@/layouts/DashboardLayoutComponents/ShiftFilter.vue";

import reportModel from "@/models/report.model";

@Component({
	components: {
		ShiftFilter,
		PaginatedSearch,
		Circle2,
	},
})
export default class ReportLumpSumPaymentsReport extends Vue {
	shiftModel: any;
	shiftFilter: any = {};
	shiftId: any = null;
	fileDownloading = false;

	constructor() {
		super();
	}

	updateFilter(filter: any)  {
		this.shiftFilter = filter;
	}

	async getReport(kind: "DOWNLOAD" | "OPEN") {
		if (!await this.validateForm()) {
			return;
		}

		this.fileDownloading = true;
		try {
			const pdfBlob = await reportModel.getLumpSumPaymentsReport(this.shiftFilter);
			if (kind === "DOWNLOAD") {
				fileDownload(pdfBlob, 'relatorio-pagamentos-a-vista.pdf');
			} else if (kind === "OPEN") {
				fileOpen(pdfBlob);
			}
		} catch (error) {
			this.$toasted.error(error.friendlyMessage || 'Não foi possível gerar o relatório. Tente novamente.');
			console.error(error);
		}
		this.fileDownloading = false;
	}

	private validateForm(): boolean {
		if (!this.shiftFilter.unit) {
			this.$toasted.error('É necessário selecionar uma unidade!');
			return false
		}

		if (!this.shiftFilter.state) {
			this.$toasted.error('É necessário selecionar um estado!');
			return false
		}

		return true
	}
}
